import * as components from './components';
import { camel2kebabCase } from '@/utils';

export const install = (app) => {
    Object.keys(components).forEach(k => {
        const name = camel2kebabCase(k);
        const comp = components[k];
        app.component(name, comp);
    });
};
